import { oldApi } from '../lib/api';

export class DeparturesApi {
  async fetchByDate(date) {
    return await oldApi.get(`/Cruiz/tablo/${date}/1`);
  }
}
